import ReactModal from 'react-modal';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBanner = styled(ReactModal)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 3rem;
  margin: 0 auto;
  width: fit-content;
`;

export const Poster = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: -1.5rem;

  img {
    border-radius: 16px;
    max-width: 550px !important;
    max-height: 550px !important;
    user-select: none;
    transition: transform 0.2s ease;

    @media (max-width: 768px) {
      max-width: 400px !important;
      max-height: 400px !important;
    }

    @media (max-width: 425px) {
      max-width: 300px !important;
      max-height: 300px !important;
    }
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }

  svg {
    color: #000;
  }
`;
